// AkustikkPremissRapport.schema.ts
import { z } from "zod";
import { ZReportChaptersSchema } from "../kapitelSchema";
import { ZAkustikkProsjektinfoSchema } from "./prosjektinfoSchema";

export const ZAkustikkPremissRapportSchema = z.object({
  generellInfo: z.object({
    oppdragsnavn: z.string(),
    oppdragsgiver: z.string(),
    emne: z.string(),
    dokumentkode: z.string(),
    kontaktperson: z.string(),
    tilgjengelighet: z.string(),
    oppdragsleder: z.string(),
    utarbeidetAv: z.string(),
    ansvarligEnhet: z.string(),
    revisjon: z.string(),
  }),
  prosjektinfo: ZAkustikkProsjektinfoSchema,
  kapitler: ZReportChaptersSchema,
});

export type IAkustikkPremissRapport = z.infer<typeof ZAkustikkPremissRapportSchema>;
